import gql from 'graphql-tag';

const GET_CAMPAIGN_ORDERS_QUEUE = gql`
  query campaignOrdersQueue(
    $where: CampaignOrderWhereInput!
    $first: Int
    $skip: Int
    $after: String
    $before: String
    $orderBy: CampaignOrderOrderByInput
    $last: Int
  ) {
    campaignOrdersConnection: campaignOrdersConnection(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          status
          startDate
          endDate
          budget
          cpm
          pricingModel
          isLaunchProgrammatically
          aggregateData {
            id
            overallData {
              id
              aggImpressions
              aggClicks
              aggEvents
            }
            byDate
          }
          pacingData {
            id
            pace
            impressionsLeft
            daysLeft
            # Pacing UX (DASHBOARD_PACING_UX_SPEC): projection framing, unstable-window
            # suppression, and the math tooltip all read these - pure selection-set
            # extension, no backend change
            daysIntoFlight
            impressionGoal
            impressionsYesterday
            dailyAvgImpressions
            expectedImpressions
            pacingStartDate
            paceYesterday
            paceSevenDaysAgo
            # Flight-window pacing entries — the source of truth the
            # campaigns table renders; the scalar pace above can reflect
            # the order window instead of the sub-campaign flight
            pacing
          }
          updatedAt
          advertiser {
            id
            CPAcronym
            level
            name
            pricingModel {
              id
              model
            }
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
          dspConfig
          renewalStatus
          IONumber
          productCode
          campaigns {
            id
            hasMediaPlanStrategy
          }
        }
      }
      aggregate {
        count
      }
    }

    full: campaignOrdersConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default GET_CAMPAIGN_ORDERS_QUEUE;
